import React, { useEffect, useRef, useState } from 'react';
import MessageBox from './message/MessageBox';
import MessageOptions from './message/MessageOptions';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';

const ChatOptions = ({ messageOptions, setMessageOptions }) => {

    const chatOptionsMessageRef = useRef();
    const [chatOptionsStatus, setChatOptionsStatus] = useState(0);

    const closeOptionsByTap = (e) => {
        if (!chatOptionsMessageRef?.current?.contains(e.target)) {
            closeOptions();
        }
    };

    const closeOptions = () => {
        setChatOptionsStatus(1);
        setTimeout(() => {
            setChatOptionsStatus(0);
            setMessageOptions(false);
        }, 300);
    };

    useEffect(() => {
        if (messageOptions?.id) {
            setChatOptionsStatus(1);
            setTimeout(() => {
                setChatOptionsStatus(2);
            }, 1);
        }
    }, [messageOptions]);

    return (
        <>
            <AnimatePresence>
            {
                chatOptionsStatus ?
                <ChatOptionsContainer
                    onClick={(e) => closeOptionsByTap(e)}
                    styles={{
                        top: messageOptions?.ref?.current?.getBoundingClientRect()?.top,
                        left: messageOptions?.ref?.current?.getBoundingClientRect()?.left,
                        width: messageOptions?.ref?.current?.getBoundingClientRect()?.width,
                        height: messageOptions?.ref?.current?.getBoundingClientRect()?.height,
                        isMocalMessage: messageOptions?.isLocalMessage,
                        chatOptionsStatus: chatOptionsStatus,
                    }}
                >
                    <div className='message-box' ref={chatOptionsMessageRef}>
                        <MessageBox
                            type='OPTIONS'
                            replyTo={messageOptions?.replyTo}
                            arrayText={messageOptions?.arrayText}
                            plainText={messageOptions?.plainText}
                            messageStyles={{
                                ...messageOptions?.messageStyles,
                                width: messageOptions?.ref?.current?.offsetWidth,
                                height: messageOptions?.ref?.current?.offsetHeight,
                                type: 'OPTIONS',
                                localmessage: messageOptions?.isLocalMessage ? 1 : 0,
                                persian: messageOptions?.isTextPersian ? 1 : 0,
                                letters: messageOptions?.textLetters,
                                position: messageOptions?.messagePosition,
                                reply: messageOptions?.replyTo != 'no_reply' ? 1 : 0,
                                chatOptionsStatus: chatOptionsStatus,
                            }}
                        />
                        <AnimatePresence>
                        {
                            chatOptionsStatus == 2 ?
                            <MessageOptions
                                options={{
                                    messageOptions: messageOptions,
                                    closeOptions: closeOptions,
                                }}
                            />
                            : ''
                        }
                        </AnimatePresence>
                    </div>
                </ChatOptionsContainer>
                : ''
            }
            </AnimatePresence>
        </>
    );
};

const ChatOptionsContainer = styled(motion.div)`
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: ${props => props.styles.chatOptionsStatus == 2 ? 'var(--bold-glass)' : 'none'};
    background-color: ${props => props.styles.chatOptionsStatus == 2 ? '#000000aa' : '#00000000'};
    transition: backdrop-filter .4s, background .4s;
    z-index: 5;

    .message-box {
        position: absolute;
        top: ${props => props.styles.chatOptionsStatus == 1 ? `${props.styles.top}px` : '50%'};
        left: ${props => `${props.styles.left}px`};
        width: ${props => `${props.styles.width}px`};
        height: ${props => `${props.styles.height}px`};
        display: flex;
        justify-content: flex-end;
        align-items: ${props => props.styles.isMocalMessage ? 'flex-end' : 'flex-start'};
        flex-direction: column;
        margin: ${props => props.styles.chatOptionsStatus == 2 && props.styles.isMocalMessage ? '0 20rem 0 0' : props.styles.chatOptionsStatus == 2 && !props.styles.isMocalMessage ? '0 0 0 2rem' : ''};
        transform: ${props => props.styles.chatOptionsStatus == 1 ? 'translate(0%, 0%) scale(1)' : 'translate(0%, -50%) scale(1.1)'};
        transition: top .25s cubic-bezier(0.53, 0, 0, 0.98),
                    transform .25s cubic-bezier(0.53, 0, 0, 0.98),
                    margin .25s cubic-bezier(0.53, 0, 0, 0.98);
    }
`;

export default ChatOptions;